import { ChainConfig, ChainKey } from "@silo/types";
import { local } from "./local";
import { ethereum } from "./ethereum";
import { arbitrum } from "./arbitrum";
import { optimism } from "./optimism";
import { anvil } from "./anvil";
import { base } from "./base";
import { satisfies } from "effect/Function";

export const CHAIN_CONFIG = satisfies<Record<ChainKey, ChainConfig>>()({
  ethereum,
  arbitrum,
  optimism,
  base,
  local,
  anvil,
} as const);
